import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { FormatNumber} from "../services/statistics.service";
import {
  getSalariesStatistics,
  selectState,
} from "../slices/SalariesStatistics.slice";
import { selectState as mainSelectState } from "../slices/main.slice";
import { mapMonths } from "utils/dateUtils";

export const SalariesStatistics = () => {
  const { statistics, loading } = useSelector(selectState);
  const { mainDateFrom } = useSelector(mainSelectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (mainDateFrom != null) {
      dispatch(getSalariesStatistics({ year: mainDateFrom?.getFullYear() }));
    }
  }, [dispatch, mainDateFrom]);

  const getHighest = () => {
    let highest = 0;
    statistics?.monthlyCosts.forEach((element) => {
      Object.values(element).forEach((val) => {
        if (val > highest) {
          highest = val;
        }
      });
    });
    return highest;
  };

  const getWidth = (num: number | undefined) => {
    if (num === 0) {
      return 0;
    }
    if (num) {
      const result = 100 / (getHighest() / num);
      return Math.round(result);
    }
  };

  return (
    <div className="extendedDiv">
      <div className="header">Plate mesečno</div>
      <div className="salaries loading-container">
        {loading && <Loader />}
        <div className="salariesGraphs">
          {statistics?.monthlyCosts &&
            statistics.monthlyCosts.map((s) => (
              <div key="{s}" className="horizontalGraph">
                <p>{mapMonths(s.month)}</p>
                <div className="horizontalGraphContent">
                  <span
                    className={`horizontalGraphWidth-${getWidth(
                      s.numberOfSalaries
                    )}`}
                  >
                    <div className="color1"></div>
                    <p>{FormatNumber(s.numberOfSalaries)}</p>
                  </span>
                  <span
                    className={`horizontalGraphWidth-${getWidth(
                      s.totalPaidAmount
                    )}`}
                  >
                    <div className="color2"></div>
                    <p>{FormatNumber(s.totalPaidAmount)}</p>
                  </span>
                  <span
                    className={`horizontalGraphWidth-${getWidth(s.paidByBank)}`}
                  >
                    <div className="color3"></div>
                    <p>{FormatNumber(s.paidByBank)}</p>
                  </span>
                  <span
                    className={`horizontalGraphWidth-${getWidth(
                      s.paidForFixedSalaries
                    )}`}
                  >
                    <div className="color4"></div>
                    <p>{FormatNumber(s.paidForFixedSalaries)}</p>
                  </span>
                  <span
                    className={`horizontalGraphWidth-${getWidth(s.bonuses)}`}
                  >
                    <div className="color12"></div>
                    <p>{FormatNumber(s.bonuses)}</p>
                  </span>
                </div>
              </div>
            ))}
        </div>
        <div className="salariesGraphsInfo">
          <span>
            <div className="color1"></div>Broj Plata
          </span>
          <span>
            <div className="color2"></div>Isplaćeno ukupno novca
          </span>
          <span>
            <div className="color3"></div>Na račun
          </span>
          <span>
            <div className="color4"></div>Fiksne plate
          </span>
          <span>
            <div className="color12"></div>Bonusi
          </span>
        </div>
      </div>
    </div>
  );
};
